import { render, staticRenderFns } from "./ProductBundles.vue?vue&type=template&id=156fb99d&scoped=true&"
import script from "./ProductBundles.vue?vue&type=script&lang=js&"
export * from "./ProductBundles.vue?vue&type=script&lang=js&"
import style0 from "./ProductBundles.vue?vue&type=style&index=0&id=156fb99d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156fb99d",
  null
  
)

export default component.exports